import * as React from 'react';
import * as styles from './slonoTopGallery.css';
import { IOfferPhoto, IPromoInfo } from '../../types/offer';
import { mergeStyles } from '@cian/utils';
import { GalleryNoImageIcon } from './galleryNoImage';
import { Button, ButtonSize } from '@cian/button-component';
import { HasVideoBadge } from '../../common/components/has_video_badge';
import { PromoInfo } from '../../common/components/promo_info';
import { HasTourBadge } from '../../common/components/HasTourBadge/HasTourBadge';

export interface ISlonoTopGallery {
  photos: IOfferPhoto[];
  hasVideo: boolean;
  isNewbuildingTourAvailable: boolean;
  promoInfo: IPromoInfo | null;
  fullUrl: string;
  /**
   * Отвечает за показ лейбла "новое"
   * Актуально только для выдачи по сохраненному поиску
   */
  isNew?: boolean;

  className?: string;

  onClick(evt: React.MouseEvent): void;
}

export const SlonoTopGallery = (props: ISlonoTopGallery) => {

  const { className, photos, hasVideo, promoInfo, isNew, fullUrl, onClick, isNewbuildingTourAvailable } = props;
  const defaultPhoto = photos.find(photo => photo.isDefault);
  const withoutDefault = photos.filter(photo => !photo.isDefault);
  const photosToShow = [defaultPhoto, ...withoutDefault].filter(Boolean);
  const photoReplacersCount = 5 - photos.length;

  return (
    <div { ...mergeStyles(className, styles['slono-top_gallery']) } onClick={ onClick }>

      {
        photosToShow.map((photo) => (
          <div key={ (photo as IOfferPhoto).thumbnailUrl } className={ styles['gallery_photo'] }>
            <img src={ (photo as IOfferPhoto).thumbnailUrl }/>
          </div>
        ))
      }

      {
        ((new Array(photoReplacersCount > 0 ? photoReplacersCount : 0)).fill(undefined)).map((item, index) => (
          <div key={ index } className={ styles['photo_replacer'] }>
            <GalleryNoImageIcon/>
          </div>
        ))
      }

      {
        photoReplacersCount < 0 &&
        <Button className={ styles['more-photos'] } size={ ButtonSize.M }>Еще фото</Button>
      }

      {
        promoInfo &&
        <PromoInfo
          containerStyle={ mergeStyles(
            styles['promo-container'],
            // istanbul ignore next : нет стиля promo-container-isnew в css
            isNew && styles['promo-container-isnew'],
          ) }
          isSpecProject={ promoInfo.specProject }
          name={ promoInfo.name }
          href={ fullUrl }
        />
      }
      <div className={ styles['badges-container'] }>
        {
          isNewbuildingTourAvailable && <HasTourBadge />
        }
        {
          hasVideo && <HasVideoBadge/>
        }
      </div>
    </div>
  );
};
